<template>
  <div id="sidebar-widgets-container">
    <SidebarPieGraphTable
      v-if="showPieChart"
      data-test="sidebar-widget-pie-chart"
      :style="pieChartFontFamily"
      class="widget-card fit-content"
      show-total
    />
    <SummaryTable data-test="sidebar-widget-summary-table" class="widget-card fit-content" />
    <div v-if="showComparisonGraph" class="widget-card sidebar-comparison-graph-container">
      <ComparisonGraph data-test="sidebar-widget-bar-chart" />
    </div>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'

import SidebarPieGraphTable from '@/components/public/GraphTable/SidebarPieGraphTable.vue'
import SummaryTable from '@/components/public/SummaryTable/SummaryTable.vue'
import ComparisonGraph from '@/components/public/Charts/ComparisonGraph.vue'
import StoryWidgetsMixin from '@/mixins/StoryWidgetsMixin'

const components = {
  SidebarPieGraphTable,
  SummaryTable,
  ComparisonGraph,
}

@Component({ components })
export default class SidebarWidgets extends StoryWidgetsMixin {}
</script>

<style lang="scss">
#sidebar-widgets-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 16px;
  .graph-table-container {
    font-family: var(--font-family);
    .table {
      color: inherit;
    }
  }

  .summary-table-container {
    padding: 1em;
  }

  .sidebar-comparison-graph-container {
    padding: 1em 1em 1em 0;
  }

  .widget-card {
    background: white;
    border-radius: var(--border-radius);
    &.fit-content {
      min-width: fit-content;
    }
  }
}
</style>
